import type { SupabaseClient } from '@supabase/supabase-js'
import { getAuthRedirectUrl } from './redirect'

/**
 * Staff / admin / web: Supabase built-in reset email.
 */
export async function sendSupabasePasswordReset(
  supabase: SupabaseClient,
  email: string,
  redirectTo: string = getAuthRedirectUrl()
): Promise<{ success: boolean; error?: string }> {
  const { error } = await supabase.auth.resetPasswordForEmail(email, {
    redirectTo
  })

  if (error) {
    return { success: false, error: error.message }
  }
  return { success: true }
}

/**
 * Circle: branded email via `circle_password_reset` edge function.
 */
export async function sendCirclePasswordReset(
  supabase: SupabaseClient,
  email: string,
  language?: string
): Promise<{ success: boolean; error?: string }> {
  try {
    const { error } = await supabase.functions.invoke('circle_password_reset', {
      body: { email, language }
    })

    if (error) {
      return { success: false, error: error.message }
    }
    return { success: true }
  } catch (err) {
    return {
      success: false,
      error:
        err instanceof Error ? err.message : 'Failed to request password reset'
    }
  }
}
